import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import HeroBanner from '../components/HeroBanner';
import { FiPhone, FiSend } from 'react-icons/fi';
import { MdShoppingCart } from 'react-icons/md';
import { FaBars } from 'react-icons/fa';
import { FaPlay } from 'react-icons/fa';
import { FaTruck, FaMedal } from 'react-icons/fa';
import { GiHoneyJar } from 'react-icons/gi';
import { MdSupportAgent } from 'react-icons/md';
import { FaQuoteLeft } from "react-icons/fa";
import { FaWhatsapp } from 'react-icons/fa';
import { AiOutlineUser } from 'react-icons/ai';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const About: React.FC = () => {
  const [cartItems, setCartItems] = useState<any[]>([]);
  const [customerName, setCustomerName] = useState<string | null>(null);
  const [testimonials, setTestimonials] = useState<any[]>([]);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const navigate = useNavigate();

  const baseURL = "https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net";

  // Toggle to show/hide the "Our satisfied customer says" testimonials section
  const SHOW_TESTIMONIALS = false;

  useEffect(() => {
    const name = localStorage.getItem("customerName");
    if (name && name.trim() !== "" && name !== "undefined") {
      setCustomerName(name);
    } else {
      setCustomerName(null);
    }
  }, []);

  const fetchCart = async () => {
    try {
      const customerId = localStorage.getItem("customerId");
      if (!customerId) return;

      const response = await axios.get(
        `https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net/Cart/GetCartByCustomerId?customerId=${customerId}`
      );

      const items = response.data.items || [];
      setCartItems(items);
    } catch (error) {
      console.error("Error fetching cart:", error);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const res = await fetch("https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net/Testimonials/GetTestimonials");
      if (!res.ok) throw new Error("Failed to fetch testimonials");
      const data = await res.json();
      setTestimonials(data);
    } catch (error) {
      console.error("Error fetching testimonials:", error);
    }
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const totalCount = cartItems.length;

  useEffect(() => {
    if (window.AOS) window.AOS.init();
    if (window.$ && window.$('.carousel-testimony').length && window.$.fn.owlCarousel) {
      window.$('.carousel-testimony').owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        items: 1,
        autoplay: true,
        autoplayTimeout: 5000,
        smartSpeed: 1000,
      });
    }
    if (window.$ && window.$('.number').length && window.$.fn.animateNumber) {
      window.$('.number').each(function (this: HTMLElement) {
        const $this = window.$(this);
        const num = $this.data('number');
        $this.animateNumber({ number: num }, 2000);
      });
    }
    const script = document.createElement('script');
    script.src = '/js/main.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="goto-here" style={{ minHeight: '100vh', background: '#fafaf6' }}>
      {/* Top Bar */}
      <div className="py-1 bg-primary" style={{ zIndex: 3, position: 'relative' }}>
        <div className="container">
          <div className="row no-gutters d-flex align-items-start align-items-center px-md-0">
            <div className="col-lg-12 d-block">
              <div className="row d-flex">
                <div className="col-md pr-4 d-flex topper align-items-center">

                  <div className="icon mr-2 d-flex justify-content-center align-items-center">
                    <FiPhone size={12} color="white" />
                  </div>
                  <span className="text">+91 9148761750</span>
                </div>
                <div className="col-md pr-4 d-flex topper align-items-center">
                  <div className="icon mr-2 d-flex justify-content-center align-items-center">
                    <FiSend size={12} color="white" />
                  </div>
                  <span className="text">care@fhome.shop</span>
                </div>
                <div className="col-md-5 pr-4 d-flex topper align-items-center text-lg-right">
                  <span className="text">3-5 Business days delivery &amp; Free Returns</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar" style={{ zIndex: 2 }}>
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img
              src="/images/fhome-logo.jpg"
              alt=""
              style={{ height: "55px", marginRight: "8px", borderRadius: "50%", width: "80px" }}
            />
            <span style={{ fontWeight: 'bold', fontSize: '20px', color: '#28a745' }}></span>
          </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#ftco-nav" aria-controls="ftco-nav" aria-expanded="false" aria-label="Toggle navigation">
            <FaBars className="mr-2" /> Menu
          </button>
          <div className="collapse navbar-collapse" id="ftco-nav">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item"><a href="/" className="nav-link">Home</a></li>
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" id="dropdown04" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Shop</a>
                <div className="dropdown-menu" aria-labelledby="dropdown04">
                  <a className="dropdown-item" href="/shop">Shop</a>
                </div>
              </li>
              <li className="nav-item active"><a href="/about" className="nav-link">About</a></li>
              <li className="nav-item"><a href="/contact" className="nav-link">Contact</a></li>
              <li className="nav-item cta cta-colored"><a href="/cart" className="nav-link">
                <span><MdShoppingCart size={18} /></span> [{totalCount}]
              </a>
              </li>
              <li className="nav-item">
                <a
                  href="/my-account"
                  className="nav-link d-flex align-items-center"
                  style={{ gap: "6px" }}
                >
                  <AiOutlineUser size={24} style={{ color: "#898989" }} />
                  {customerName ? (
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#999",
                        maxWidth: "120px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      }}
                      title={`Hi, ${customerName}`}
                    >
                      Hi, {customerName}
                    </span>
                  ) : (
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#999"
                      }}
                    >
                      Account
                    </span>
                  )}
                </a>
              </li>

              <li className="nav-item ml-2">
                <button
                  onClick={() => navigate("/login")}
                  className="btn btn-success"
                  style={{
                    padding: "8px 20px",
                    fontSize: "14px",
                    fontWeight: "600",
                    borderRadius: "4px",
                    border: "none",
                    cursor: "pointer",
                    backgroundColor: "#28a745"
                  }}
                >
                  Login
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Hero Section */}
      <HeroBanner image="images/fhome-ingredients-rustic.jpg" minHeight="350px">
        <div className="row no-gutters slider-text align-items-center justify-content-center" style={{ minHeight: '350px' }}>
          <div className="col-md-9 ftco-animate text-center">
            <p className="breadcrumbs"><span className="mr-2"><a href="/">Home</a></span> <span>About us</span></p>
            <h1 className="mb-0 bread">About us</h1>
          </div>
        </div>
      </HeroBanner>
      {/* About Section */}
      <section className="ftco-section ftco-no-pb ftco-no-pt bg-light" style={{ position: 'relative', zIndex: 2, marginTop: '-100px', paddingTop: '0' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-5 p-md-5 img img-2 d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(images/about.jpg)`, minHeight: '400px', backgroundSize: 'cover', backgroundPosition: 'center' }}>
              <a href="https://vimeo.com/45830194" className="icon popup-vimeo d-flex justify-content-center align-items-center" style={{ width: 90, height: 90, background: '#8cc63f', borderRadius: '50%', position: 'relative', zIndex: 3 }}>
                <FaPlay style={{ color: '#fff', fontSize: 20 }} />
              </a>
            </div>
            <div className="col-md-7 py-5 wrap-about pb-md-5 ftco-animate" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '400px' }}>
              <div className="heading-section-bold mb-4 mt-md-5">
                <div className="ml-md-0">
                  <h2 className="mb-4">Welcome to F.home - Fresh From Home</h2>
                </div>
              </div>
              <div className="pb-md-5">
                <p>F.home - Fresh From Home was founded with a simple mission: to bring pure, authentic, and naturally produced food directly from farms to every home.</p>
                <p>We carefully source our grains, pulses, native rice varieties, and farm-fresh produce from our farms and local farm communities which support farmers. We also offer traditionally prepared products such as wood-pressed oils, homemade cow ghee, handcrafted masalas, and other wholesome foods.</p>
                <p>At F.home, quality is our highest priority. Every product is prepared and packed with care, ensuring No Artificial Colours, No Preservatives, and No Additives - only honest, natural goodness for your family.</p>
                <p>Our goal is to preserve the taste and nutrition of traditional foods while supporting local farms and farm societies. Through direct sourcing and convenient home delivery, we bridge the gap between the farm and your dining table.</p>
                <p>Our motto, "Farm to Home," reflects our commitment to providing fresh, safe, and nutritious food that helps build a healthier community. Every F.home product is a promise of purity, authenticity, and trust.</p>
                <p>
                  <a
                    href="/shop"
                    className="btn btn-primary"
                    style={{
                      background: '#8cc63f',
                      color: '#fff',
                      border: '2px solid #b2d235',
                      borderRadius: '25px',
                      fontWeight: 500,
                      fontSize: '18px',
                      padding: '8px 32px',
                      boxShadow: '0 0 0 4px #e6f3d6',
                      transition: 'all 0.2s',
                    }}
                    onMouseOver={e => {
                      (e.currentTarget as HTMLAnchorElement).style.background = '#b2d235';
                      (e.currentTarget as HTMLAnchorElement).style.color = '#fff';
                    }}
                    onMouseOut={e => {
                      (e.currentTarget as HTMLAnchorElement).style.background = '#8cc63f';
                      (e.currentTarget as HTMLAnchorElement).style.color = '#fff';
                    }}
                  >
                    Shop now
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Newsletter Section */}
      <section className="ftco-section ftco-no-pt ftco-no-pb py-5 bg-light">
        <div className="container py-4">
          <div className="row d-flex justify-content-center py-5">
            <div className="col-md-6">
              <h2 style={{ fontSize: 22 }} className="mb-0">Subcribe to our Newsletter</h2>
              <span>Get e-mail updates about our latest shops and special offers</span>
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <form action="#" className="subscribe-form">
                <div className="form-group d-flex">
                  <input type="text" className="form-control" placeholder="Enter email address" />
                  <input type="submit" value="Subscribe" className="submit px-3" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* Counter Section */}
      <section className="ftco-section ftco-counter img" id="section-counter" style={{ backgroundImage: `url(images/bg_3.jpg)`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="container">
          <div className="row justify-content-center py-5">
            <div className="col-md-10">
              <div className="row">
                <div className="col-md-3 d-flex justify-content-center counter-wrap ftco-animate">
                  <div className="block-18 text-center">
                    <div className="text">
                      <strong className="number" data-number="10000">0</strong>
                      <span>Happy Customers</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 d-flex justify-content-center counter-wrap ftco-animate">
                  <div className="block-18 text-center">
                    <div className="text">
                      <strong className="number" data-number="100">0</strong>
                      <span>Branches</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 d-flex justify-content-center counter-wrap ftco-animate">
                  <div className="block-18 text-center">
                    <div className="text">
                      <strong className="number" data-number="1000">0</strong>
                      <span>Partner</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 d-flex justify-content-center counter-wrap ftco-animate">
                  <div className="block-18 text-center">
                    <div className="text">
                      <strong className="number" data-number="100">0</strong>
                      <span>Awards</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimony Section */}
      {SHOW_TESTIMONIALS && (
        <section className="ftco-section testimony-section" style={{ background: '#fff' }}>
          <div className="container">
            <div className="row justify-content-center mb-5 pb-3">
              <div className="col-md-7 heading-section ftco-animate text-center">
                <span className="subheading">Testimony</span>
                <h2 className="mb-4">Our satisfied customer says</h2>
                <p>Every F.home product is a promise of purity, authenticity, and trust - bringing fresh, safe, and nutritious food from farm to home.</p>
              </div>
            </div>
            <div className="row ftco-animate">
              <div className="col-md-12">
                {testimonials.length > 0 ? (
                  <Swiper
                    modules={[Autoplay, Pagination]}
                    autoplay={{ delay: 5000 }}
                    pagination={{ clickable: true }}
                    loop
                    spaceBetween={20}
                    slidesPerView={3}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                        spaceBetween: 10
                      },
                      640: {
                        slidesPerView: 2,
                        spaceBetween: 15
                      },
                      1024: {
                        slidesPerView: 3,
                        spaceBetween: 20
                      }
                    }}
                  >
                    {testimonials.map((item, index) => (
                      <SwiperSlide key={index}>
                        <div className="testimonial-card">
                          {/* USER IMAGE */}
                          <div
                            className="testimonial-img-square"
                            style={{
                              backgroundImage: `url(${baseURL + item.userImageUrl})`,
                              cursor: "pointer"
                            }}
                            onClick={() => setSelectedImage(baseURL + item.userImageUrl)}
                          />

                          {/* MESSAGE */}
                          <p className="testimonial-text">
                            "Excellent service and fresh products. Totally worth it!"
                          </p>

                          {/* NAME */}
                          <h6 className="testimonial-name">Happy Customer</h6>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <div className="text-center p-5">
                    <p>Loading testimonials...</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      )}
      {/* Services Section */}
      <section className="ftco-section bg-light" style={{ zIndex: 2, position: 'relative' }}>
        <div className="container">
          <div className="row no-gutters ftco-services">
            <div className="col-lg-3 text-center d-flex align-self-stretch ftco-animate">
              <div className="media block-6 services mb-md-0 mb-4">
                <div className="icon bg-color-1 active d-flex justify-content-center align-items-center mb-2">
                  <FaTruck size={30} color="#fff" />
                </div>
                <div className="media-body">
                  <h3 className="heading">Free Shipping</h3>
                  <span>On order over ₹100</span>
                </div>
              </div>
            </div>
            <div className="col-lg-3 text-center d-flex align-self-stretch ftco-animate">
              <div className="media block-6 services mb-md-0 mb-4">
                <div className="icon bg-color-2 d-flex justify-content-center align-items-center mb-2">
                  <GiHoneyJar size={30} color="#fff" />
                </div>
                <div className="media-body">
                  <h3 className="heading">Always Fresh</h3>
                  <span>Product well package</span>
                </div>
              </div>
            </div>
            <div className="col-lg-3 text-center d-flex align-self-stretch ftco-animate">
              <div className="media block-6 services mb-md-0 mb-4">
                <div className="icon bg-color-3 d-flex justify-content-center align-items-center mb-2">
                  <FaMedal size={30} color="#fff" />
                </div>
                <div className="media-body">
                  <h3 className="heading">Superior Quality</h3>
                  <span>Quality Products</span>
                </div>
              </div>
            </div>
            <div className="col-lg-3 text-center d-flex align-self-stretch ftco-animate">
              <div className="media block-6 services mb-md-0 mb-4">
                <div className="icon bg-color-4 d-flex justify-content-center align-items-center mb-2">
                  <MdSupportAgent size={30} color="#fff" />
                </div>
                <div className="media-body">
                  <h3 className="heading">Support</h3>
                  <span>24/7 Support</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer Section */}
      <Footer />
      <a
        href="https://wa.me/c/919148761750"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp size={40} color="#25D366" />
      </a>

      {/* IMAGE MODAL/POPUP */}
      {selectedImage && (
        <div 
          className="image-modal-backdrop"
          onClick={() => setSelectedImage(null)}
        >
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="image-modal-close"
              onClick={() => setSelectedImage(null)}
            >
              ✕
            </button>
            <img 
              src={selectedImage} 
              alt="Testimonial" 
              className="image-modal-img"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default About;

